// APRouteWrapper.tsx
import React from "react";
import { Route, useRouteMatch, RouteComponentProps } from "react-router-dom";

interface APRouteWrapperProps {
  /** The default status if no URL parameter is provided */
  defaultStatus: string;
  /** A render prop that receives the base URL and active status */
  children: (props: {
    baseUrl: string;
    activeStatus: string;
  }) => React.ReactNode;
}

export const APRouteWrapper: React.FC<APRouteWrapperProps> = ({
  defaultStatus,
  children,
}) => {
  const outerMatch = useRouteMatch();
  return (
    <Route
      path={`${outerMatch.path}/:status?`}
      render={(matchProps: RouteComponentProps<{ status?: string }>) => {
        const activeStatus = matchProps.match.params.status || defaultStatus;
        return children({ baseUrl: outerMatch.url, activeStatus });
      }}
    />
  );
};
